/**
 * @author        quanquan
 * @dateTime      2020-07-30 09:32:16
 * @description   verification
 */

/* eslint-disable */

/**
 * Verification phone
 * value {Number} *
 */
export const checkPhone = value => {
  const telreg = /^1[0-9]{10}$/
  if (!telreg.test(value)) {
    return false
  } else {
    return true
  }
}

/**
 * Verification email
 * value {String} *
 */
export const checkEmail = value => {
  const reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g // eslint-disable-line
  if (!reg.test(value)) {
    return false
  } else {
    return true
  }
}


/**
 * Verification ipaddr
 * ip {String} *
 */
export const checkip = ip => {
  var pcount = 0
  var ip_length = ip.length
  var ip_letters = '1234567890.'
  for (var p = 0; p < ip_length; p++) {
    var ip_char = ip.charAt(p)
    if (ip_letters.indexOf(ip_char) == -1) {
      return false
    }
  }
  for (var u = 0; u < ip_length; u++) { (ip.substr(u, 1) == '.') ? pcount++ : pcount }
  if (pcount != 3) { return false }
  var firstp = ip.indexOf('.')
  var lastp = ip.lastIndexOf('.')
  var str1 = ip.substring(0, firstp)
  var ipstr_tmp = ip.substring(0, lastp)
  var secondp = ipstr_tmp.lastIndexOf('.')
  var str2 = ipstr_tmp.substring(firstp + 1, secondp)
  var str3 = ipstr_tmp.substring(secondp + 1, lastp)
  var str4 = ip.substring(lastp + 1, ip_length)
  if (str1 == '' || str2 == '' || str3 == '' || str4 == '') { return false }
  if (str1.length > 3 || str2.length > 3 || str3.length > 3 || str4.length > 3) { return false }
  if (str1 <= 0 || str1 > 255) { return false } else if (str2 < 0 || str2 > 255) { return false } else if (str3 < 0 || str3 > 255) { return false } else if (str4 < 0 || str4 > 255) { return false }
  return true
}



// WEBPACK FOOTER //
// ./src/js/module/utils/verification.js